export default class BaseStep {

    _MultiStepForms = null;

    constructor (MultiStepFormsClass) {
        this._MultiStepForms = MultiStepFormsClass;

        if (this._MultiStepForms) {
            this._init();
        }
    }


    _init() {}
}